import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
import global from 'common'

import { PerksProgramGeneralDetails } from 'core/application/csiDashboard/csiSearch/perks/getPerksProgramDetails'

import { parseZoneFormat } from 'common/dateFormatters'

interface PerksGeneralDetailsProps {
  generalDetails: PerksProgramGeneralDetails
}
const PerksGeneralDetails: React.FC<PerksGeneralDetailsProps> = (props) => {
  const { t: translate } = useTranslation()

  return (
    <div>
      <div>
        <h5>{translate('csi-dashboard.program-details.general-details')}</h5>
      </div>
      <div className="flex flex__space_between">
        <global.components.dataDisplay.Item
          translate={translate}
          title={translate('csi-dashboard.program-details.primary-admin')}
          text={props.generalDetails.primaryAdmin.firstName + ' ' + props.generalDetails.primaryAdmin.lastName}
        />
        <global.components.dataDisplay.Item
          translate={translate}
          title={translate('csi-dashboard.program-details.primary-admin-email')}
          text={props.generalDetails.primaryAdmin.workEmail}
        />
        <global.components.dataDisplay.Item
          translate={translate}
          title={translate('csi-dashboard.program-details.company-main-phone-number')}
          text={props.generalDetails.mainPhoneNumber}
        />
        <global.components.dataDisplay.Item
          translate={translate}
          title={translate('csi-dashboard.program-details.admin-direct-work-phone-number')}
          text={props.generalDetails.primaryAdmin.workPhone}
        />
      </div>

      <div className="flex flex__space_between mb-32">
        <global.components.dataDisplay.Item
          translate={translate}
          title={translate('csi-dashboard.program-details.ein')}
          text={props.generalDetails.primaryAdmin.identificationNumber}
        />
      </div>

      <h5>Benefit Details</h5>
      <Row gutter={16}>
        <Col>
          <global.components.dataDisplay.Item
            translate={translate}
            title={'Benefit start date'}
            text={parseZoneFormat(props.generalDetails.benefit.benefitStartDate)}
          />
        </Col>

        <Col>
          <global.components.dataDisplay.Item
            translate={translate}
            title={'Notification date'}
            text={
              props.generalDetails.benefit.notificationDate
                ? parseZoneFormat(props.generalDetails.benefit.notificationDate)
                : ''
            }
          />
        </Col>
      </Row>
    </div>
  )
}

export default PerksGeneralDetails
